import { render, staticRenderFns } from "./TjLogin.vue?vue&type=template&id=3a4d699c&scoped=true&"
import script from "./TjLogin.vue?vue&type=script&lang=js&"
export * from "./TjLogin.vue?vue&type=script&lang=js&"
import style0 from "./TjLogin.vue?vue&type=style&index=0&id=3a4d699c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4d699c",
  null
  
)

export default component.exports